export const productionLineEn = {
    title: 'Production lines',
    list: 'Production line list',
    detail: 'Production line detail',
    create: 'Create production line',
    delete: 'Delete production line',
    deleteConfirm: 'Are you sure you want to delete this production line?',
    columns: {
        id: 'ID',
        name: 'Name',
        actions: 'Actions'
    },
    model: {
        name: 'Production line name',
        organization: 'Organization'
    },
    errors: {
        fetchFailed: 'Failed to load production lines',
        createFailed: 'Failed to create production line',
        updateFailed: 'Failed to update production line',
        deleteFailed: 'Failed to delete production line'
    },
    success: {
        created: 'Production line created successfully',
        updated: 'Production line updated successfully',
        deleted: 'Production line deleted successfully'
    }
}
